import { Typography, withStyles } from '@material-ui/core'
import React from 'react'
import { FonteLiberacaoEnum } from './FonteLiberacao'

export const StatusEnum = {
  ABERTO: 'Aberto',
  REABERTO: 'Reaberto',
  ANALISE: 'Análise',
  REANALISE: 'Reanálise',
  PENDENTE: 'Pendente',
  // PENDENTEGESTOR: 'Pendente Monitoramento',
  LIBERADA: 'Liberada',
  LIBERADANAORECOMENDADA: 'Liberada Não Recomendada',
  LIBERADAAUTOMATICAMENTE: 'Liberada automaticamente',
  LIBERADACOMPENDENCIA: 'Liberada com pendência',
  LIBERADAGESTOR: 'Liberada gestor',
  LIBERADAMONITORAMENTO: 'Liberada com Monitoramento',
  NAORECOMENDADA: 'Não recomendada',
  CANCELADA: 'Cancelada',
  STANDBY: 'Stand-by'
}

export const StatusEnumAbrev = {
  [StatusEnum.ABERTO]: 'Aberto',
  [StatusEnum.REABERTO]: 'Reaberto',
  [StatusEnum.ANALISE]: 'Análise',
  [StatusEnum.REANALISE]: 'Reanálise',
  [StatusEnum.PENDENTE]: 'Pendente',
  [StatusEnum.PENDENTEGESTOR]: 'Pendente Monitoramento',
  [StatusEnum.LIBERADA]: 'Liberada',
  [StatusEnum.LIBERADAAUTOMATICAMENTE]: 'Liberada Automaticamente',
  [StatusEnum.LIBERADACOMPENDENCIA]: 'Liberada com Pendência',
  [StatusEnum.LIBERADAGESTOR]: 'Liberada Gestor',
  [StatusEnum.LIBERADAMONITORAMENTO]: 'Liberada com Monitoramento',
  [StatusEnum.NAORECOMENDADA]: 'Não Recomendada',
  [StatusEnum.CANCELADA]: 'Cancelada',
  [StatusEnum.STANDBY]: 'Stand-by'
}

export const InvertStatusEnum = Object.entries(StatusEnum).reduce((p, c) => {
  const [key, value] = c
  p[value] = key
  return p
}, {})

export const StatusColors = {
  ABERTO: '#ededed',
  ABERTO_DARK: '#9e9e9e',
  REABERTO: '#e3e3e3',
  REABERTO_DARK: '#aeaeae',
  ANALISE: '#fff176',
  ANALISE_DARK: '#fbc02d',
  REANALISE: '#ffb74d',
  REANALISE_DARK: '#f57c00',
  PENDENTE: '#e57373',
  PENDENTE_DARK: '#e53935',
  PENDENTEGESTOR: '#ce93d8',
  PENDENTEGESTOR_DARK: '#8e24aa',
  DELEGARASSISTENTE: '#f8bbd0',
  DELEGARASSISTENTE_DARK: '#ec407a',
  LIBERADA: '#81c784',
  LIBERADA_DARK: '#388e3c',
  LIBERADANAORECOMENDADA: '#9fa8da',
  LIBERADAAUTOMATICAMENTE: '#80cbc4',
  LIBERADAAUTOMATICAMENTE_DARK: '#00897b',
  LIBERADACOMPENDENCIA: '#a1887f',
  LIBERADACOMPENDENCIA_DARK: '#6d4c41',
  LIBERADAGESTOR: '#64b5f6',
  LIBERADAGESTOR_DARK: '#1976d2',
  LIBERADAMONITORAMENTO: '#ff7043',
  LIBERADAMONITORAMENTO_DARK: '#e64a19',
  NAORECOMENDADA: '#9fa8da',
  NAORECOMENDADA_DARK: '#3949ab',
  CANCELADA: '#bdbdbd',
  CANCELADA_DARK: '#616161'
}

const CustomTypography = withStyles(() => ({
  root: {
    lineHeight: 1.43,
    fontSize: '.875rem'
  }
}))(Typography)

export function BadgeStatus({ status, cenario, fonteLiberacao }) {
  const descricaoCenario =
    StatusEnum.LIBERADA === status ? cenario?.descricao : undefined

  const isNaoRecomendada = fonteLiberacao === FonteLiberacaoEnum.NAO_RECOMENDAR
  const statusColor = isNaoRecomendada
    ? StatusEnum.LIBERADANAORECOMENDADA
    : status

  const isFichaLiberada = status === StatusEnum.LIBERADA
  const statusFormatted = isFichaLiberada ? `${status} Mercadoria` : status

  return (
    <div
      style={{
        padding: 10,
        borderRadius: 10,
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
        backgroundColor: StatusColors[InvertStatusEnum[statusColor]],
        textAlign: 'center',
        lineHeight: '100%',
        minWidth: 200
      }}
    >
      <CustomTypography>{statusFormatted}</CustomTypography>
      <CustomTypography>{descricaoCenario}</CustomTypography>
    </div>
  )
}
